import { planningAPI } from "../../axios";

export const actions = {
    //Planning Template
    GetMainTargetByTemplate(context, data){
        return planningAPI.get(`PlanningTemplateMainTarget/PlanningTemplate/${data}`);
    },
    GetSingleMainTarget(context, data){
        return planningAPI.get(`PlanningTemplateMainTarget/${data}`);
    },
    GetMainTargetByIndicator(context, data){
        return planningAPI.get(`PlanningTemplateMainTarget/PlanningTemplate/${data.templateId}/IndicatorItem/${data.indicatorId}`);
    },
    UpdateMainTarget(context, data){
        return planningAPI.put(`PlanningTemplateMainTarget/Update/${data.id}`, data);
    },
    DeleteMainTarget(context, data){
        return planningAPI.delete(`PlanningTemplateMainTarget/Delete/${data}`);
    },
    CreateMainTarget(context, data){
        return planningAPI.post(`PlanningTemplateMainTarget/Add`, data);
    },
    AvailablePrePlanningTarget(context, data){
        return planningAPI.get(`PlanningTemplateMainTarget/Available/PlanningTarget/${data.id}/${data.cycle}`);
    },
    ImportPrePlanningTarget(context, data){
        return planningAPI.post(`PlanningTemplateMainTarget/Import/PrePlanningTarget/${data.id}/${data.includeAPI}`, data.values);
    },

    //Actual
    GetMainItems(context, data){
        return planningAPI.get(`MainTarget/Items/${data.campusId}/${data.indicatorItemId}/${data.cycle}`);
    },
    GetAvailableDU(context, data){
        return planningAPI.get(`MainTarget/Available/DeliveryUnits/${data}`);
    },
    GetSingleItem(context, data){
        return planningAPI.get(`MainTarget/${data}`);
    },
    CreateMainItems(context, data){
        return planningAPI.post(`MainTarget/Add`, data);
    },
    UpdateMainItem(context, data){
        return planningAPI.put(`MainTarget/Update/${data.id}`, data);
    },
    DeleteMainItem(context, data){
        return planningAPI.delete(`MainTarget/Remove/${data}`);
    },
    AvailablePlanningTarget(context, data){
        return planningAPI.get(`MainTarget/Available/PlanningTarget/${data}`);
    },
    ImportPlanningTarget(context, data){
        return planningAPI.post(`MainTarget/Import/PlanningTarget/${data.id}`, data.value);
    },
    SendPlanningTarget(context, data){
        return planningAPI.post(`MainTarget/Import/Planning/DeliveryUnit/${data.id}/${data.cycle}`);
    },
}